<template>
  <section id="health-tags" class="card">
    <header class="card__head">
      <span class="step">2</span>
      <div>
        <strong>用户标签</strong>
        <p>根据报告、设备和用药数据动态更新会员画像</p>
      </div>
      <em>实时更新中</em>
    </header>
    <div class="tags">
      <div>
        <p class="block-title">当前会员标签</p>
        <div class="tag-box">
          <button
            v-for="tag in member.tags"
            :key="tag.labelId || tag.id"
            type="button"
            class="tag is-on"
            :disabled="removing"
            @click="$emit('remove', tag)"
          >{{ tag.labelName }}<i>×</i></button>
          <span v-if="!member.tags.length" class="empty-tip">暂无已生效标签</span>
        </div>
        <p class="block-title">推荐标签</p>
        <div v-loading="labelLoading" class="tag-row">
          <span v-for="item in member.recommends" :key="'r-' + item.id" class="recommend">
            <button type="button" class="tag is-add" :disabled="adding" @click="$emit('adopt', item)">+ {{ item.labelName }}</button>
            <button type="button" class="tag" @click="$emit('ignore', item)">忽略</button>
            <em class="recommend-reason">{{ item.reason }}</em>
          </span>
          <button
            v-for="item in recommendLabelPool"
            :key="'l-' + item.id"
            type="button"
            class="tag is-add"
            :disabled="adding"
            @click="$emit('pick', item)"
          >+ {{ item.labelName }}</button>
          <span v-if="!hasRecommend && !labelLoading" class="empty-tip">暂无可用标签</span>
        </div>
        <button type="button" class="primary" style="margin-top:12px;" :disabled="generating" @click="$emit('generate')">
          {{ generating ? '正在生成推荐...' : '触发智能推荐' }}
        </button>
      </div>
      <aside class="tag-feed">
        <div class="tag-feed__title"><i></i>最近一次智能更新</div>
        <p>{{ member.lastAutoUpdateText || '暂无智能更新记录' }}</p>
        <div class="tag-feed__foot">
          <span></span>
          <em>{{ member.lastAutoUpdateTime || '' }}</em>
        </div>
      </aside>
    </div>
  </section>
</template>

<script>
import { listMemberLabels } from '@/api/healthManage/index';

/**
 * 用户标签
 * 字典：GET /system/memberLabel/list
 * 添加：POST /memberLabelRecommend/relation/add { memberId, labelId }
 * 删除：DELETE /memberLabelRecommend/relation/{memberId}/{labelId}
 */
export default {
  name: 'MemberLabels',
  props: {
    member: { type: Object, required: true },
    generating: { type: Boolean, default: false },
    adding: { type: Boolean, default: false },
    removing: { type: Boolean, default: false }
  },
  data() {
    return {
      labelLoading: false,
      labelList: []
    };
  },
  computed: {
    occupiedLabelIds() {
      const ids = new Set();
      (this.member.tags || []).forEach((tag) => {
        if (tag.labelId != null) ids.add(String(tag.labelId));
        else if (tag.id != null) ids.add(String(tag.id));
      });
      (this.member.recommends || []).forEach((item) => {
        if (item.labelId != null) ids.add(String(item.labelId));
      });
      return ids;
    },
    recommendLabelPool() {
      return this.labelList.filter((item) => !this.occupiedLabelIds.has(String(item.id)));
    },
    hasRecommend() {
      return (this.member.recommends || []).length > 0 || this.recommendLabelPool.length > 0;
    }
  },
  created() {
    this.loadLabelList();
  },
  methods: {
    loadLabelList() {
      this.labelLoading = true;
      listMemberLabels().then((res) => {
        const list = Array.isArray(res.data) ? res.data : [];
        this.labelList = list.filter((item) => item.isShow == 1);
      }).finally(() => {
        this.labelLoading = false;
      });
    }
  }
};
</script>
